import { render } from "./RichTextEditorCmp.vue?vue&type=template&id=0b59bdc7"
import script from "./RichTextEditorCmp.vue?vue&type=script&lang=js"
export * from "./RichTextEditorCmp.vue?vue&type=script&lang=js"

import "./RichTextEditorCmp.vue?vue&type=style&index=0&id=0b59bdc7&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__